import script from "./GoodsSchedule.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoodsSchedule.vue?vue&type=script&setup=true&lang=ts"

import "./GoodsSchedule.vue?vue&type=style&index=0&id=bcdf8ee0&lang=scss"

const __exports__ = script;

export default __exports__